// src/components/pages/Philosophy.tsx
import React from 'react';
// ↓↓↓ 実際のプロジェクト構造に合わせてパスを調整してください ↓↓↓
import {
  PageContainer,       // 汎用ページコンテナ (GlobalStyles で定義されていると仮定)
  CommonPageTitle,     // 汎用ページタイトル (GlobalStyles で定義されていると仮定)
  IntroText,
  SubHeading,
  ContentParagraph,
  EmphasisText,
  StyledList,
  StyledListItem,
  CallToActionText,
} from '../styles/GlobalStyles'; // グローバルスタイルのインポート

const Philosophy: React.FC = () => {
  return (
    <PageContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <CommonPageTitle>私たちの理念</CommonPageTitle>

      <IntroText>
        テクノロジーの力で、より良い未来を創造し、すべての人々と社会に貢献する。
      </IntroText>

      <ContentParagraph>
        合同会社Ludyworksは、革新的なアイデアと最先端の技術を駆使し、お客様のビジネス課題を解決するだけでなく、その先にある社会全体の発展を見据えています。私たちは、単なるサービス提供者ではなく、お客様と共に未来を切り拓くパートナーでありたいと考えています。
      </ContentParagraph>

      <SubHeading>私たちのミッション (Mission)</SubHeading>
      <ContentParagraph>
        <EmphasisText>「創造性と技術力で、人々の可能性を最大限に引き出し、豊かな社会を実現する」</EmphasisText>
        <br />
        私たちは、デジタル技術が持つ無限の可能性を信じています。お客様一人ひとりの、そして組織全体のポテンシャルを最大限に開花させるためのソリューションを提供し続けることが、私たちの使命です。
      </ContentParagraph>

      <SubHeading>私たちのビジョン (Vision)</SubHeading>
      <ContentParagraph>
        <EmphasisText>「最も信頼され、刺激を与え続けるテクノロジーパートナーとなる」</EmphasisText>
        <br />
        常に変化し続ける市場環境において、私たちは最先端の知識と技術を追求し続けます。お客様の期待を超える価値を提供し、長期的な信頼関係を構築することで、業界をリードする存在となることを目指します。
      </ContentParagraph>

      <SubHeading>私たちのバリュー (Values)</SubHeading>
      <StyledList>
        <StyledListItem>
          <EmphasisText>顧客中心主義 (Client-Centric):</EmphasisText> 常にお客様の視点に立ち、真の課題解決と成功を追求します。お客様の満足が私たちの最大の喜びです。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>革新への挑戦 (Innovation):</EmphasisText> 現状に満足することなく、常に新しい技術やアイデアに挑戦し、より良いソリューションを生み出し続けます。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>共創と尊重 (Collaboration & Respect):</EmphasisText> 社内外を問わず、多様な価値観を尊重し、オープンなコミュニケーションを通じて共に成長し、成果を創出します。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>誠実さと透明性 (Integrity & Transparency):</EmphasisText> あらゆる活動において高い倫理観を持ち、誠実かつ透明性の高い対応を心がけます。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>継続的な学習と成長 (Continuous Learning & Growth):</EmphasisText> 個人の成長が組織の成長に繋がると信じ、学び続ける文化を育み、常に進化し続けます。
        </StyledListItem>
      </StyledList>

      <SubHeading>社会への約束</SubHeading>
      <ContentParagraph>
        Ludyworksは、事業活動を通じて得た知見や技術を社会に還元し、持続可能な社会の実現に貢献することを目指しています。特に、教育機会の提供や地域社会との連携を通じて、次世代の育成と社会全体のデジタルトランスフォーメーションを支援してまいります。SDGsへの取り組みも積極的に推進し、地球環境への配慮と社会的責任を果たしていきます。
      </ContentParagraph>

      <CallToActionText>
        私たちの理念に共感いただける皆様と共に、新しい価値を創造できることを楽しみにしています。
      </CallToActionText>

    </PageContainer>
  );
};

export default Philosophy;